import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of as observableOf } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { UserService } from '®shared/user';

import {
  UserSearchActionTypes,
  UserSearchFailedAction,
  UserSearchInitiatedAction,
  UserSearchResultsLoadedAction,
} from './user-search.actions';

@Injectable()
export class UserSearchEffects {
  constructor(private actions$: Actions, private userService: UserService) {}

  searchForUsers$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(UserSearchActionTypes.USER_SEARCH_INITIATED),
      switchMap(({ payload }: UserSearchInitiatedAction) =>
        this.userService.searchUsers(payload.searchTerm, payload.limit).pipe(
          map(
            results =>
              new UserSearchResultsLoadedAction({ ...payload, results }),
          ),
          catchError(error =>
            observableOf(new UserSearchFailedAction({ ...payload, error })),
          ),
        ),
      ),
    ),
  );
}
